export function getPathFromParam(param: string | string[]): string[] {
  return (Array.isArray(param) ? param : param.split('/')).filter(Boolean)
}

export enum ContentType {
  Djurfakta = 'djurfakta',
  Article = 'article',
}

export enum FilterCategory {
  Artikel = 'artikel',
  Kategori = 'kategori',
  Sektion = 'sektion',
}

export const typeTranslationMap = {
  [ContentType.Djurfakta]: 'Fakta om djur',
  [ContentType.Article]: 'Artikel',
} as const

export const filterTranslationMap = {
  [FilterCategory.Artikel]: 'Artikel',
  [FilterCategory.Kategori]: 'Kategori',
  [FilterCategory.Sektion]: 'Sektion',
} as const
